module.exports = __webpack_public_path__ + "img/img19.d85deff0.png";